module.exports = __webpack_public_path__ + "img/list49.7bc68ac8.jpeg";